var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Tooltip",
    {
      attrs: {
        title: "Removed from the company",
        tooltipClasses: "w-full",
        placement: "top",
        disabled: _vm.disabled,
        variant: _vm.Variants.DARK,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }